import Progress from './Progress';
import Bar from './Bar';
Progress.Bar = Bar;
export default Progress;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-progress/src/index.js